import React, {useEffect, useState} from 'react'
import FailedModal from "../../../CustomModal/Failed";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import Header from "../../../layout/header";
import useLatLng from "../../../../hooks/uselatlng/uselatlng";
import {toast} from "react-toastify";
import SuccessModal from "../../../CustomModal/Success";

const RescheduleValetActivity = ({
                                history,
                                match,
                                rescheduleActivity,
                                rescheduleActivityDetails
                            }) => {

    const islatlng = useLatLng();
    const [isLoading, setIsLoading] = useState(false)
    const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
    const [countToOpenModal, setCountToOpenModal] = useState(0)
    const [inputList, setInputList] = useState([{
        scheduleDate:'', meta_data:{}, lat:'', long:''
    }])
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const [userMessage, setUserMessage] = useState('')
    const [type, setType] = useState("Dealer")

    useEffect(() => {
        if(parseInt(match?.params?.type) === 2){
            setType("toll")
        }
    }, [])
    const handleInput = (key, val, metaKey, e) => {
        let list = [...inputList]
        if (key === 'meta_data') {
            inputList[0][key][metaKey] = val
        } else {
            inputList[0][key] = val
        }
        setInputList(list)
    }

    useEffect(() => {
        setIsFailedModalOpen(false)
        setIsSuccessModalOpen(false)
        if (parseInt(rescheduleActivityDetails?.status) === 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsSuccessModalOpen(true)
            setUserMessage(rescheduleActivityDetails?.message)
        } else if (rescheduleActivityDetails?.status !== undefined && rescheduleActivityDetails?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsFailedModalOpen(true)
            setUserMessage(rescheduleActivityDetails?.message)
        }
    }, [rescheduleActivityDetails])

    const handleSubmit = async (e) => {
        e.preventDefault()
        let list = [...inputList]
        list[0]['id'] = match?.params?.id
        list[0]['type'] = ''
        if(islatlng?.lat === null || islatlng?.lng === null ){
            toast.error("Enable your location")
            return false
        }
        list[0]['lat'] = islatlng?.lat
        list[0]['long'] = islatlng?.lng

        setIsLoading(true)
        await rescheduleActivity(list[0])
        setIsLoading(false)
    }

    return (
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={userMessage}
                url={`valet-activity-list/${match?.params?.opportunity_id}/${match?.params?.account_id}`}
            />

            <FailedModal
                isOpen={isFailedModalOpen}
                msg={userMessage}
                countToOpenModal={countToOpenModal}
            />
            <Loader isLoading={isLoading}/>

            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={"Reschedule Activity"}
                            history={history}
                        />
                        {/*BODY*/}

                        <div className="container-fluid common-bg">
                                <>
                                    <form onSubmit={(e) => handleSubmit(e)}>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    {/*<h1 className="h3 mb-0 text-black-100">*/}
                                                    {/*    <span style={{color: "green"}}>Reschedule Activity</span>*/}
                                                    {/*</h1>*/}
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 mtk-075 float-field">
                                                                <input type="datetime-local"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           handleInput('scheduleDate', e.target.value, e)
                                                                       }}
                                                                       required
                                                                       id="validationCustom01"
                                                                       min={new Date().toISOString().split('T')[0] + "T00:00"}
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Reschedule Date
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mtk-075 float-field mb-4">
                                                            <textarea
                                                                className="form-control form-control-user"
                                                                placeholder=" Reason"
                                                                onChange={(e) => {
                                                                    handleInput('meta_data', e.target.value, 'reason', e)
                                                                }}
                                                                required
                                                                id="validationCustom01"
                                                                rows="4" cols="50"
                                                            />
                                                                <label className="large-label float-lb">
                                                                    {/*Description*/}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/*</div>*/}
                                                <div className="col-md-12 mt-4 d-flex">
                                                    <button className="btn btn-primary btn-user btn-block submit-btn">
                                                        Submit
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default RescheduleValetActivity